/**
 * @generated SignedSource<<ccc1cb82e99c6aafede53d67e2a4a944>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppBuildState = "DISABLED" | "PENDING_BRAND_SETUP" | "PENDING_KINN_SETUP" | "PRE_PRODUCTION" | "PRODUCTION" | "%future added value";
export type SalesChannelAttributionMethod = "NATIVE_CART" | "SERIALIZED_GRAPHQL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InternHome_query$data = {
  readonly internBrands: ReadonlyArray<{
    readonly androidPushNotificationRequiresFcmv1Migration: boolean;
    readonly appConfig: {
      readonly appState: AppBuildState;
      readonly salesChannelAttributionMethod: SalesChannelAttributionMethod | null;
    };
    readonly appleDeveloperAgreementsPendingSince: any | null;
    readonly displayName: string;
    readonly facebookConfig: {
      readonly id: string;
      readonly needsReauth: boolean;
    } | null;
    readonly id: string;
    readonly iosPushNotificationCredentialsRequireServiceKeyMigration: boolean;
    readonly isBrandAdmin: boolean;
    readonly shopifyConfig: {
      readonly id: string;
      readonly multipassEnabled: boolean;
      readonly tokenState: string;
    } | null;
    readonly showIosTosAlert: boolean;
    readonly tempoApiToken: string | null;
  }>;
  readonly user: {
    readonly isSuperuser: boolean;
  } | null;
  readonly " $fragmentType": "InternHome_query";
};
export type InternHome_query$key = {
  readonly " $data"?: InternHome_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternHome_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternHome_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserType",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSuperuser",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandType",
      "kind": "LinkedField",
      "name": "internBrands",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isBrandAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLFacebookClientConfig",
          "kind": "LinkedField",
          "name": "facebookConfig",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "needsReauth",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appleDeveloperAgreementsPendingSince",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showIosTosAlert",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tempoApiToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosPushNotificationCredentialsRequireServiceKeyMigration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidPushNotificationRequiresFcmv1Migration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandShopifyConfigType",
          "kind": "LinkedField",
          "name": "shopifyConfig",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "multipassEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tokenState",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigType",
          "kind": "LinkedField",
          "name": "appConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salesChannelAttributionMethod",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "2e5f70b49c3a0597f992c6bfa19047e9";

export default node;
